import { Component } from 'react';
import { Button, Container, Stack, Typography } from '@mui/material';

// Catches a render error in the page below it, so one broken page shows a
// message instead of blanking the whole dashboard. When nothing throws it
// renders its children as they are, with no extra element around them.
// Errors in event handlers and in async code are not render errors, so they
// pass through unchanged.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Console only. Sentry needs a DSN from the owner and is not part of this.
    console.error('Dashboard page error:', error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Container maxWidth="sm">
        <Stack role="alert" spacing={2} alignItems="flex-start" sx={{ py: 6 }}>
          <Typography variant="h4">
            Something went wrong on this page.
          </Typography>
          <Typography color="text.secondary">
            The rest of the dashboard still works. Reload the page to try again,
            or pick another page from the menu.
          </Typography>
          <Button variant="contained" onClick={this.handleReload}>
            Reload page
          </Button>
        </Stack>
      </Container>
    );
  }
}
